/**
 * Record Item Component
 * Displays a single IR document record (announcement, press release, etc.)
 * 
 * Layout: [Name] [Date] with PDF link
 */
import React from 'react'
import styled from '@emotion/styled'
import { format } from 'date-fns'
import { IRDocument, LangKey } from '../types'
import { getLangFieldKey } from '../utils/lang'

interface RecordItemProps extends IRDocument {
  langKey: string
  isLast: boolean
}

const RecordLink = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f9f9f9;
    color: #ff6637;
  }

  span:first-of-type {
    flex: 1;
    padding-right: 2rem;
  }

  span:last-of-type {
    color: #999;
    font-size: 0.9rem;
    white-space: nowrap;
  }
`

const RecordItem: React.FC<RecordItemProps> = ({ name, date, file, langKey, isLast }) => {
  const lang = langKey === 'zhHant' ? 'zhHant' : 'en'
  const displayName = name[lang]
  const fileUrl = file?.[lang]?.asset?.url

  if (!displayName) return null

  // Format date
  let displayDate = date
  try {
    if (date) {
      const d = new Date(date)
      displayDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
        d.getDate()
      ).padStart(2, '0')}`
    }
  } catch (e) {
    displayDate = date
  }

  return (
    <RecordLink href={fileUrl} target="_blank" rel="noreferrer">
      <span>{displayName}</span>
      <span>{displayDate}</span>
    </RecordLink>
  )
}

export default RecordItem
